<template>
    <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model.system.workflow">
        <div class="contact-block">
            <div class="container" data-aos="fade-in">
                <div class="row">
                    <div class="col-lg-6">
                        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                            <div class="title" v-if="model.elements.title.value">
                                <h3>{{ model.elements.title.value }}</h3>
                            </div>
                        </SmartLinkStandaloneElement>
                        <SmartLinkStandaloneElement :codename="type.elements.description.codename">
                            <div class="description" v-if="!isEmpty(model?.elements?.description?.value)">
                                <RichText :value="model.elements.description.value"/>
                            </div>
                        </SmartLinkStandaloneElement>
                        <SmartLinkStandaloneElement :codename="type.elements.title.codename">
                            <div class="cta" v-if="model?.elements?.call_to_action?.value?.length > 0">
                                <CallToAction v-for="cta in pageStore.getListAs<CallToActionModel>(model.elements.call_to_action.value)" :model="cta"/>
                            </div>
                        </SmartLinkStandaloneElement>
                    </div>
                </div>
            </div>
        </div>
    </SmartLinkItemComponent>
</template>
<script lang="ts" setup>
import { contentTypes, type CallToActionModel, type ContactBlockModel } from '~~/app/models';
const type = contentTypes.contact_block;

const pageStore = usePageStore();
const props = defineProps<{model:ContactBlockModel}>();
</script>